// extracted by mini-css-extract-plugin
export default {"sider":"Sider_sider__B9vO8","collapsed":"Sider_collapsed__NF5mJ","bottom":"Sider_bottom__yDvnU"};